import { helper } from '@ember/component/helper';

const TREND_ICON_MAP: Record<string, IconName> = {
	positive: 'PerformanceUpOld',
	neutral: 'PerformanceStableOld',
	negative: 'PerformanceDownOld',
	unavailable: 'PerformanceUnavailableOld',
	disabled: 'PerformanceUnavailableOld',
};

const DEFAULT_ICON: IconName = 'PerformanceUnavailableOld';

const trendIconName = function (params: [string | undefined]): IconName {
	const trend = params[0];
	if (!trend) {
		return DEFAULT_ICON;
	}
	return TREND_ICON_MAP[trend] ?? DEFAULT_ICON;
};

const trendIconNameHelper = helper(trendIconName);

export default trendIconNameHelper;
